const CONSENT_STORAGE_KEY = 'genufit_analytics_consent'

export type AnalyticsConsentState = 'granted' | 'denied' | 'unknown'

export function getAnalyticsConsent(): AnalyticsConsentState {
  if (import.meta.env.VITE_POSTHOG_CONSENT_BYPASS === 'true') {
    return 'granted'
  }

  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
    if (stored === 'granted' || stored === 'denied') {
      return stored
    }
  } catch {
    // localStorage unavailable (SSR/tests)
  }

  return 'unknown'
}

export function setAnalyticsConsent(state: Exclude<AnalyticsConsentState, 'unknown'>): void {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, state)
  } catch {
    // ignore
  }
}

export function hasAnalyticsConsent(): boolean {
  return getAnalyticsConsent() === 'granted'
}
